import { filters as customerFilters } from "../loyaltyCustomer";
import { customerTableHeaderMessages } from "../loyaltyCustomer/messages";
import { inputFilter } from "../shared/crud/filter-widgets";
import { TableFilters } from "../shared/crud/list";
import { Message } from "../shared/i18n";
import { ReportItem } from "./index";

// We want to tie our filters to the customer filters / headers
export type FilterKeys = "transactionDate" | keyof typeof customerTableHeaderMessages;
type FilterValuesMap = { [k in FilterKeys]: any };
export class FilterValues implements Partial<FilterValuesMap> {
  "location.address"?: string;
  "location.city"?: string;
  "location.country"?: string;
  "location.zipCode"?: string;
  active?: string;
  address?: string;
  birthDate?: string;
  city?: string;
  country?: string;
  createdAt?: { startDate: Date; endDate: Date };
  emailAddress?: string;
  id?: string;
  idHelpText?: string;
  lastName?: string;
  legalIdentifier?: string;
  name?: string;
  organizationsList?: string;
  phoneNumber?: string;
  referrer?: string;
  referrerLong?: string;
  tagsList?: string;
  tierType?: string;
  transactionDate?: { startDate: Date; endDate: Date };
  zipCode?: string;
}

const filterMessages: Record<FilterKeys, Message> = {
  ...customerTableHeaderMessages,
  transactionDate: {
    id: "loyaltyCustomerTransactionReport.transactionDate",
    defaultMessage: "transaction date",
  },
};
const filters: FilterKeys[] = ["transactionDate", ...customerFilters] as FilterKeys[];

// Since we will have filters that are not present in the table, we need to find a ways of providing
// translations for them, so we add a new prop called title.
interface ExtraFilterProp {
  title: Message;
}
const extraFilterProps: Record<FilterKeys, ExtraFilterProp> = filters.reduce((acc, it) => {
  return {
    ...acc,
    [it]: {
      title: filterMessages[it],
    },
  };
}, {} as Record<FilterKeys, ExtraFilterProp>);

export const tableFilters: TableFilters<
  ReportItem & { transactionDate: string },
  FilterValues
> = filters.reduce(
  (accum, curr) => ({
    ...accum,
    [curr]: {
      filterFn: "async",
      widget: inputFilter,
      ...(extraFilterProps[curr] || {}),
    },
  }),
  {}
);
